import { 
  Button, 
  Typography,
} from "@mui/material";
import {
  Edit as EditIcon,
  Save as SaveIcon,
  ArrowBackOutlined as ArrowBackOutlinedIcon,
} from '@mui/icons-material';
import React from "react";
import { EditRecipeHeaderContainer } from "./styled";

const Header = React.memo(({ isEditing, setIsEditing, onSave, onNavigateBack }) => {
  return (
    <EditRecipeHeaderContainer>
      <Button
        onClick={onNavigateBack}
        color='secondary'
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          width: '6rem'
        }}
      >
        <ArrowBackOutlinedIcon />
        <Typography variant='h7' color='secondary'>
          Back
        </Typography>
      </Button>
      
      <Button
        color='secondary'
        startIcon={isEditing ? <SaveIcon /> : <EditIcon />}
        onClick={() => isEditing ? onSave() : setIsEditing(true)}
      >
        {isEditing ? 'Save' : 'Edit'}
      </Button>
    </EditRecipeHeaderContainer>
  );
});

export default Header;